import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Select, Checkbox, Space, Radio } from "antd";
import { Wrapper } from "../style";

const { Option } = Select;


function AddNewAlerts({
                          isModalVisible,
                          handleCancel,
                          handleSubmit,
                          editing,
                          asinList,
                          alertCategories,
                          alertDataMap
                      }) {

    const [form] = Form.useForm();
    const receiveOnWatch = Form.useWatch('receive_on', form);

    const [loading, setLoading] = useState(false); // Only used for submission loading now

    const [alertTypes, setAlertTypes] = useState({});

    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedAlertType, setSelectedAlertType] = useState(null);
    const [alertLogicType, setAlertLogicType] = useState(null);
    const [localSelectedAsins, setLocalSelectedAsins] = useState([]);

    useEffect(() => {
        const types = {};
        Object.entries(alertDataMap.types).forEach(([category, typeMap]) => {
            types[category] = Object.entries(typeMap).map(([key, label]) => ({
                label,
                value: key
            }));
        });
        setAlertTypes(types);

        if (editing) {
            let asinArray = [];
            try {
                asinArray = typeof editing.asin_list === "string" ? JSON.parse(editing.asin_list) : editing.asin_list;
            } catch (err) {
                console.error("Failed to parse asin_list:", err);
            }
            setLocalSelectedAsins(Array.isArray(asinArray) ? asinArray : []);

            const logic = alertDataMap.logicTypeMap?.[editing.type]?.type || "Default";
            setAlertLogicType(logic);
        } else {
            setLocalSelectedAsins([]);
            setAlertLogicType(null);
        }

    }, [alertDataMap.types, alertDataMap.logicTypeMap, editing]);

    useEffect(() => {
        if (editing) {
            let frequencyValue = 2;
            let daysValue = null;

            if (editing.frequency !== "Everytime") {
                frequencyValue = 1;
                daysValue = parseInt(editing.frequency, 10);
            }

            form.setFieldsValue({
                ...editing,
                alertType: editing.type,
                frequency: frequencyValue,
                days: daysValue,
                receive_on: editing.receive_on || [],
                severity: editing.severity || "Medium",
            });

            setSelectedCategory(editing.category);
            setSelectedAlertType(editing.type);

        } else {
            form.resetFields();
            setSelectedCategory(null);
            setSelectedAlertType(null);
            setAlertLogicType(null);
            form.setFieldsValue({
                frequency: 2,
                severity: "Medium",
            });
        }
    }, [editing, isModalVisible]);


    const handleOk = async () => {
        try {
            const values = await form.validateFields();

            const payload = {
                name: values.name,
                category: values.category,
                type: values.alertType,
                frequency: values.frequency === 1 ? `${values.days}` : "Everytime",
                receive_on: values.receive_on || [],
                asin_list: localSelectedAsins || [],
                severity: values.severity,
            };

            // Access logic map from props
            if (alertDataMap.logicTypeMap?.[values.alertType]?.type === "Custom") {
                payload.user_input = values.user_input;
            }

            handleSubmit(payload);
        } catch (errorInfo) {
            console.log("Validation Failed:", errorInfo);
        }
    };

    return (
        <>
            <Modal
                visible={isModalVisible}
                title={editing ? "Edit Alerts" : "Add New Alerts"}
                onCancel={handleCancel}
                width={600}
                destroyOnClose
                footer={[
                    <>
                        <button type="button" class="btn btn-light me-3" onClick={handleCancel}>Close</button>
                        <button type="button" class="btn btn-danger " loading={loading} onClick={handleOk}>{editing ? "Update" : "Save"} </button>
                    </>
                ]}

            >
                <Wrapper>
                    <div className="modal_custom add-alert">
                        {/* Initial values are good practice for Radio defaults */}
                        <Form form={form} layout="vertical" name="expenseForm" initialValues={{ frequency: 2, severity: "Medium" }}>

                            {/* Expense Title and Amount */}
                            <div className="row g-5 mb-0 align-items-center">
                                <div className="col-md-12">
                                    <Form.Item label="" name="name" className="mb-0 fw-bold"
                                               rules={[{required: true, message: "Please enter alert name"}]}>
                                        <Input className="form-control form-control-solid fs-7"
                                               placeholder="Enter Alert Name"/>
                                    </Form.Item>

                                </div>

                                {/* Category */}
                                <div className="col-md-6">
                                    <Form.Item
                                        name="category"
                                        label=""
                                        rules={[{required: true, message: "Please select a category"}]}
                                        className="mb-4 fw-bold"
                                    >
                                        <Select
                                            placeholder="Select Category"
                                            onChange={(value) => {
                                                setSelectedCategory(value);
                                                form.setFieldsValue({alertType: undefined});
                                            }}
                                        >
                                            {/* ✨ UPDATED: Use alertCategories prop */}
                                            {alertCategories.map(option => (
                                                <Option key={option.value} value={option.value}>{option.label}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </div>

                                <div className="col-md-6">
                                    <Form.Item
                                        name="alertType"
                                        label=""
                                        rules={[{required: true, message: "Please select an alert type"}]}
                                        className="mb-4"
                                    >
                                        <Select
                                            placeholder="Select Alert Type"
                                            disabled={!selectedCategory}
                                            onChange={(value) => {
                                                setSelectedAlertType(value);

                                                // ✨ UPDATED: Access logic map from props
                                                const logic =
                                                    alertDataMap.logicTypeMap?.[value]?.type || "Default";

                                                setAlertLogicType(logic);
                                                form.setFieldsValue({user_input: null});
                                            }}
                                        >
                                            {/* Use local alertTypes state derived from props */}
                                            {alertTypes[selectedCategory]?.map((option) => (
                                                <Option key={option.value} value={option.value}>
                                                    {option.label}
                                                </Option>
                                            )) || null}
                                        </Select>
                                    </Form.Item>
                                </div>


                                {/* ASIN List */}
                                <div className="col-md-12">
                                    <Form.Item className="fw-bold mb-4" label="">
                                        <Select
                                            mode="multiple"
                                            placeholder="Select or Search ASIN"
                                            className="w-100"
                                            size="large"
                                            value={localSelectedAsins}
                                            onChange={setLocalSelectedAsins}
                                            loading={loading}
                                            optionLabelProp="value"
                                            maxTagCount={"responsive"}
                                        >
                                            {asinList.map((item) => (
                                                <Option key={item.asin} value={item.asin}>
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "10px"
                                                        }}
                                                    >
                                                        <img
                                                            src={
                                                                item.image ||
                                                                "https://app.sellerview.ai/sellerview_api/images/no-product-image.png"
                                                            }
                                                            alt={item.name}
                                                            className="w-50px"
                                                        />
                                                        <div>
                                                            <div style={{fontWeight: "500"}}>{item.name}</div>
                                                            <div style={{fontSize: "13px", color: "#888"}}>
                                                                {item.asin}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </div>

                                <div className="col-md-12">
                                    {/* Custom Input for 'Custom' logic types */}
                                    {alertLogicType === "Custom" && (
                                        <div className="col-md-12">
                                            <Form.Item
                                                label=""
                                                name="user_input"
                                                className="mb-4"
                                                rules={[
                                                    {required: true, message: "Please enter a threshold value"}
                                                ]}
                                            >
                                                <Space>
                                                    <div className="fw-bold fs-7">
                                                        {/* ✨ UPDATED: Access description from props */}
                                                        {
                                                            alertDataMap.logicTypeMap?.[selectedAlertType]?.description ||
                                                            "Enter threshold percentage"
                                                        }
                                                    </div>
                                                    <Input
                                                        type="number"
                                                        className="w-125px fs-7"
                                                        placeholder="Percentage"
                                                        suffix="%"
                                                        variant="filled"
                                                        size="large"
                                                    />
                                                </Space>
                                            </Form.Item>
                                        </div>
                                    )}
                                </div>

                                {/* Notification Frequency */}
                                <div className="col-md-12">
                                    <Form.Item name="frequency" className="d-flex align-items-center fw-bold">
                                        <Radio.Group name="notificationFrequency">
                                            <Space direction="vertical">
                                                <Radio value={1} className="">
                                                    Send me a notification every
                                                    <Form.Item
                                                        name="days"
                                                        noStyle
                                                        shouldUpdate={(prev, curr) => prev.frequency !== curr.frequency}
                                                        rules={[{
                                                            required: form.getFieldValue('frequency') === 1,
                                                            message: "Required"
                                                        }]}
                                                    >
                                                        <Input
                                                            type="number"
                                                            min={1}
                                                            className="w-125px mx-3 fs-7"
                                                            size="middle"
                                                            variant="filled"
                                                            placeholder="Number of days"
                                                            disabled={form.getFieldValue('frequency') !== 1}
                                                        />
                                                    </Form.Item>
                                                    day(s)
                                                </Radio>
                                                <Radio className="mt-3" value={2}>
                                                    Send me a notification every time the change happens.
                                                </Radio>
                                            </Space>
                                        </Radio.Group>
                                    </Form.Item>
                                </div>

                                {/* Severity Field */}
                                <div className="col-md-12">
                                    <Form.Item
                                        name="severity"
                                        label="Severity"
                                        className="fw-bold"
                                        rules={[{required: true, message: "Please select a severity level"}]}
                                    >
                                        <Radio.Group>
                                            <Radio value="Minor">Minor</Radio>
                                            <Radio value="Major">Major</Radio>
                                            <Radio value="Critical">Critical</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                </div>

                                {/* Receive Alert On */}
                                <div className="col-md-12">
                                    <Form.Item name="receive_on" className="fw-bold" label="Receive Alert On">
                                        <Checkbox.Group>
                                            {/* ✨ UPDATED: Use alertDataMap.receive_on prop */}
                                            {alertDataMap.receive_on.map((option) => (
                                                <Checkbox key={option} value={option}>
                                                    {option}
                                                </Checkbox>
                                            ))}
                                        </Checkbox.Group>
                                    </Form.Item>
                                </div>

                                {receiveOnWatch?.includes('Email') && (
                                    <div className="col-md-12">
                                        <Form.Item
                                            label="Email"
                                            name="email"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Please enter an email address"
                                                },
                                                {
                                                    pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                                    message: "Please enter a valid email"
                                                }
                                            ]}
                                        >
                                            <Input className="form-control form-control-solid fs-7"
                                                   placeholder="Enter Email Address"/>
                                        </Form.Item>
                                    </div>
                                )
                                }

                            </div>

                        </Form>
                    </div>
                </Wrapper>
            </Modal>
        </>
    );
}

export default AddNewAlerts;